"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var InternalClientActionType;
(function (InternalClientActionType) {
    InternalClientActionType["TEST_CONNECTION"] = "TEST_CONNECTION";
    InternalClientActionType["TEST_CONNECTION_COMPLETE"] = "TEST_CONNECTION_COMPLETE";
    InternalClientActionType["TEST_CONNECTION_FAILED"] = "TEST_CONNECTION_FAILED";
    InternalClientActionType["GET_EVENT_RESULTS_DATA"] = "GET_EVENT_RESULTS_DATA";
    InternalClientActionType["GET_EVENT_RESULTS_DATA_STARTED_POLLING"] = "GET_EVENT_RESULTS_DATA_STARTED_POLLING";
    InternalClientActionType["GET_EVENT_RESULTS_DATA_STOP_POLLING"] = "GET_EVENT_RESULTS_DATA_STOP_POLLING";
    InternalClientActionType["GET_EVENT_RESULTS_DATA_STOPPED_POLLING"] = "GET_EVENT_RESULTS_DATA_STOPPED_POLLING";
    InternalClientActionType["GET_EVENT_RESULTS_DATA_UPDATE"] = "GET_EVENT_RESULTS_DATA_UPDATE";
    InternalClientActionType["GET_EVENT_RESULTS_ERROR"] = "GET_EVENT_RESULTS_ERROR";
    InternalClientActionType["GET_INDIVIDUAL_RESULTS_DATA"] = "GET_INDIVIDUAL_RESULTS_DATA";
    InternalClientActionType["GET_INDIVIDUAL_RESULTS_DATA_STARTED_POLLING"] = "GET_INDIVIDUAL_RESULTS_DATA_STARTED_POLLING";
    InternalClientActionType["GET_INDIVIDUAL_RESULTS_DATA_STOP_POLLING"] = "GET_INDIVIDUAL_RESULTS_DATA_STOP_POLLING";
    InternalClientActionType["GET_INDIVIDUAL_RESULTS_DATA_STOPPED_POLLING"] = "GET_INDIVIDUAL_RESULTS_DATA_STOPPED_POLLING";
    InternalClientActionType["GET_INDIVIDUAL_RESULTS_DATA_UPDATE"] = "GET_INDIVIDUAL_RESULTS_DATA_UPDATE";
    InternalClientActionType["GET_INDIVIDUAL_RESULTS_ERROR"] = "GET_INDIVIDUAL_RESULTS_ERROR";
    InternalClientActionType["GET_EVENT_SUMMARY"] = "GET_EVENT_SUMMARY";
    InternalClientActionType["GET_EVENT_SUMMARY_COMPLETE"] = "GET_EVENT_SUMMARY_COMPLETE";
    InternalClientActionType["GET_EVENT_SUMMARY_ERROR"] = "GET_EVENT_SUMMARY_ERROR";
    InternalClientActionType["GET_MEDIA_DATA"] = "GET_MEDIA_DATA";
    InternalClientActionType["GET_MEDIA_DATA_STARTED_POLLING"] = "GET_MEDIA_DATA_STARTED_POLLING";
    InternalClientActionType["GET_MEDIA_DATA_STOP_POLLING"] = "GET_MEDIA_DATA_STOP_POLLING";
    InternalClientActionType["GET_MEDIA_DATA_STOPPED_POLLING"] = "GET_MEDIA_DATA_STOPPED_POLLING";
    InternalClientActionType["GET_MEDIA_DATA_UPDATE"] = "GET_MEDIA_DATA_UPDATE";
    InternalClientActionType["GET_MEDIA_ERROR"] = "GET_MEDIA_ERROR";
    InternalClientActionType["GET_META_DATA"] = "GET_META_DATA";
    InternalClientActionType["GET_META_DATA_COMPLETE"] = "GET_META_DATA_COMPLETE";
    InternalClientActionType["GET_META_DATA_ERROR"] = "GET_META_DATA_ERROR";
    InternalClientActionType["SUBSCRIBE_ERROR"] = "SUBSCRIBE_ERROR";
    InternalClientActionType["UNSUBSCRIBE_ERROR"] = "UNSUBSCRIBE_ERROR";
})(InternalClientActionType = exports.InternalClientActionType || (exports.InternalClientActionType = {}));
//# sourceMappingURL=types.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/athlinks-results-client/dist/src/actions/internal/types.js
 ** module id = 41
 ** module chunks = 0
 **/